import React from 'react'

const Partnership = ({
  size,
  style,
  primaryColor,
  secondaryColor,
  title = 'icon/partnership',
  ...props
}) => (
  <svg height='75' width='121' viewBox='0 0 121 75' style={style} {...props}>
    <g fill='none' fillRule='evenodd'>
      <path
        d='M79.263 36.974s7.899 7.28 7.899 10.58v8.055a4.738 4.738 0 0 0 4.74 4.736c2.617 0 4.738-2.12 4.738-4.736V44.554c0-5.054-18.528-23.28-21.8-23.689-2.528-.316-9.795 8.212-14.219 12.318-4.422 4.106-9.636-.158-9.636-.158 0-.947 8.372-21.635 19.43-24.16 7.853-1.795 12.007 1.052 16.905 3.21 4.897 2.159 11.532 6.264 14.059 6.264h17.31v34.427H106.01'
        stroke={primaryColor}
        strokeWidth='2.25'
        strokeLinecap='round' />
      <path
        d='M68.205 63.03a4.738 4.738 0 0 0 4.739 4.738c2.618 0 4.74-2.12 4.74-4.738V52.765c-.317-6-4.424-7.895-4.424-7.895'
        stroke={primaryColor}
        strokeWidth='2.25'
        strokeLinecap='round'
        strokeLinejoin='round' />
      <path
        d='M87.162 48.817v11.055a4.738 4.738 0 0 1-4.74 4.738 4.738 4.738 0 0 1-4.739-4.738v-1.895'
        stroke={primaryColor}
        strokeWidth='2.25'
        strokeLinecap='round'
        strokeLinejoin='round' />
      <path
        d='M59.266 67.169a4.58 4.58 0 0 1-1.237-6.358l3.766-5.58a4.582 4.582 0 0 1 6.36-1.235 4.578 4.578 0 0 1 1.235 6.356l-3.764 5.58a4.582 4.582 0 0 1-6.36 1.237zM48.208 67.169a4.58 4.58 0 0 1-1.237-6.358l7.067-10.473a4.582 4.582 0 0 1 6.36-1.237 4.579 4.579 0 0 1 1.237 6.358l-7.067 10.473a4.582 4.582 0 0 1-6.36 1.237zM38.097 65.59a4.58 4.58 0 0 1-1.236-6.359l10.478-15.53a4.584 4.584 0 0 1 6.36-1.236 4.579 4.579 0 0 1 1.237 6.358l-10.48 15.53a4.582 4.582 0 0 1-6.36 1.236z'
        stroke={primaryColor}
        strokeWidth='2.25' />
      <path
        d='M31.146 59.588a4.58 4.58 0 0 1-1.236-6.358l7.067-10.473a4.58 4.58 0 1 1 7.596 5.121l-7.067 10.474a4.582 4.582 0 0 1-6.36 1.236z'
        stroke={primaryColor}
        strokeWidth='2.25' />
      <path
        d='M68.205 9.18c-13.903-5.686-24.961 5.37-37.914 9.16H2.333v37.426h17.295l.021-37.319'
        stroke={primaryColor}
        strokeWidth='2.25'
        strokeLinecap='round' />
      <path
        d='M14.409 47.557a3.557 3.557 0 1 1-7.115-.002 3.557 3.557 0 0 1 7.115.002'
        fill={secondaryColor} />
    </g>
  </svg>
)

export default Partnership
